module.exports = __webpack_public_path__ + "static/media/under_construction.37ade1b6.svg";